export const COUNTRY_SHORT_NAMES = {
  AE: 'AE',
  IQ: 'IQ',
  QA: 'QA',
  SA: 'SA',
}; // more coming soon

export const isAE = (country: string | undefined): boolean => country?.toUpperCase() === COUNTRY_SHORT_NAMES.AE;
export const isQA = (country: string | undefined): boolean => country?.toUpperCase() === COUNTRY_SHORT_NAMES.QA;
export const isIQ = (country: string | undefined): boolean => country?.toUpperCase() === COUNTRY_SHORT_NAMES.IQ;
